import { useEffect } from "react";
import { fetchDealershipInventoryList } from "../services/dealership";
import { useDealershipContext } from "../contexts/dealershipContext";
import { DEALERSHIP_CONFIG } from "../config/dealershipConfig";
export function useFetchInventoryList(
  setInventoryList,
  setInventoryListRequestPending
) {
  const { dealershipId } = useDealershipContext();
  const inventoryIds = DEALERSHIP_CONFIG[dealershipId]
    ?.dealershipInventoryIdList || [dealershipId];
  useEffect(() => {
    const getInventoryList = async () => {
      let allInventory = [];
      for (const id of inventoryIds) {
        const { inventoryList } = await fetchDealershipInventoryList(id);
        allInventory.push(...inventoryList);
      }
      console.log(allInventory?.length, "inventoryList Length");
      setInventoryList(allInventory);
      setInventoryListRequestPending(false);
    };
    getInventoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealershipId]);
}
